<template>
    <div
        v-show="showModal"
        class="modal-wrapper"
    >
        <div class="modal-container">
            <p class="modal-title">
                <i class="el-icon-warning text-warning"></i>
                <span class="title">
                    {{actionText}} : {{resourceName}}{{blankingText}}
                </span>
                <i
                    class="el-icon-close close-icon"
                    @click="close"
                ></i>
            </p>
            <p class="modal-text">You're about to {{action}} the following resource :</p>
            <p class="resource-name">{{resourceName}}{{blankingText}}</p>
            <div v-if="action === 'restart'">
                <p class="modal-text">
                    {{isVM?'This action may temporarily impact blanking.':'This action may cause disruptions on the taker side.'}}
                    It will take up to 5 minutes to restart the resource, and it cannot be undone.
                </p>
                <div class="button-container">
                    <el-button
                        type="primary"
                        size="medium"
                        class="actions-button cancel-button"
                        @click="close"
                    >
                        Cancel
                    </el-button>
                    <el-button
                        type="primary"
                        size="medium"
                        class="actions-button"
                        @click="restart()"
                    >
                        Restart resource
                    </el-button>
                </div>
            </div>
            <div v-else-if="action === 'reconfigure'" >
                <p class="modal-text">
                    This action will impact the delivery of the channel. It will take up to 5 minutes to reconfigure the taker, and it cannot be undone until it is complete.
                </p>
                <p class="modal-text">
                    To confirm your choice please type “RECONFIGURE” in the field below :
                </p>
                <el-form
                    ref="form"
                    :model="form"
                    :rules="rules"
                >
                    <el-form-item class="gcmcn-form-input" prop="passPhrase">
                        <el-input  v-model="form.passPhrase" placeholder="RECONFIGURE"></el-input>
                    </el-form-item>
                </el-form>
                <div class="button-container">
                    <el-button
                        type="primary"
                        size="medium"
                        class="actions-button cancel-button"
                        @click="close"
                    >
                        Cancel
                    </el-button>
                    <el-button
                        type="danger"
                        size="medium"
                        class="actions-button"
                        :disabled="isDisabled"
                        @click="reconfigureTaker()"
                    >
                        Reconfigure taker
                    </el-button>
                </div>
            </div>
            <div v-else >
                <p
                    v-if="moduleType === 'DELIVERY'"
                    class="modal-text"
                >
                    <span class="important-text">Takers will have to reconfigure their receiver and this must be done in coordination with the customer.</span><br>
                    The resource must be destroyed first in order to be recreated. It will take up to 5 minutes to recreate the resource, and it cannot be undone.
                </p>
                <p
                    v-else
                    class="modal-text"
                >
                    The resource must be destroyed first in order to be recreated.
                    {{isVM?'This may temporarily impact blanking.':'Takers will have to reconfigure their receiver.'}} It will take up to 5 minutes to recreate the resource, and it cannot be undone.
                </p>
                <p class="modal-text">
                    To confirm your choice please type “RECREATE” in the field below :
                </p>
                <el-form
                    ref="form"
                    :model="form"
                    :rules="rules"
                >
                    <el-form-item class="gcmcn-form-input" prop="passPhrase">
                        <el-input  v-model="form.passPhrase" placeholder="RECREATE"></el-input>
                    </el-form-item>
                </el-form>
                <div class="button-container">
                    <el-button
                        type="primary"
                        size="medium"
                        class="actions-button cancel-button"
                        @click="close"
                    >
                        Cancel
                    </el-button>
                    <el-button
                        type="danger"
                        size="medium"
                        class="actions-button"
                        :disabled="isDisabled"
                        @click="recreate()"
                    >
                        Recreate resource
                    </el-button>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {

    name: 'actionConfirmModal',
    props:{
    },
    data () {
        return {
            showModal: false,
            action:'',
            resource: null,
            resourceName:'',
            redundancyType: '',
            moduleType: '',
            flowArn: '',
            flowUid: '',
            confUid: '',
            isVM: false,
            form:{
                passPhrase: '',
            },
            rules:{
                passPhrase: [{ validator: this.checkConfirm, required: true}],
            }
        };
    },
    computed:{
        actionText(){
            if(this.action === 'restart'){
                return 'Restart';
            }
            if(this.action === 'recreate'){
                return 'Recreate';
            }
            if(this.action === 'reconfigure'){
                return 'Reconfigure';
            }
        },
        blankingText(){
            if (this.isVM && this.action !=='reconfigure'){
                return'\'s blanking VM';
            }
            return '';
        },
        passPattern(){
            if(this.action === 'recreate'){
                return 'RECREATE';
            }
            if(this.action === 'reconfigure'){
                return 'RECONFIGURE';
            }
        },
        isDisabled(){
            if(this.form.passPhrase === this.passPattern){
                return false;
            }
            return true;
        }
    },
    methods:{
        open(
            action,
            resourceName,
            resource,
            redundancyType,
            moduleType,
            flowArn,
            flowUid,
            confUid,
            isVM,
            resourceIsFeed
        ){
            this.showModal = true;
            this.action = action;
            this.resourceName = resourceName;
            this.resource = resource;
            this.redundancyType = redundancyType;
            this.moduleType = moduleType;
            this.flowArn = flowArn;
            this.flowUid = flowUid;
            this.confUid = confUid;
            this.isVM = isVM;
            this.resourceIsFeed = resourceIsFeed;
        },
        close(){
            this.showModal = false;
            this.action = '';
            this.resourceName = '';
            this.form.passPhrase = '';
            this.resource = null;
            this.redundancyType = '';
            this.moduleType = '';
            this.flowArn = '';
            this.flowUid = '';
            this.confUid = '';
            this.isVM = false;
            this.resourceIsFeed = false;
            if(this.$refs.form){
                this.$refs.form.clearValidate();
            }
        },
        checkConfirm (rule, value, callback) {
            if(!value){
                return callback(new Error('Pass phrase is required'));
            }else if(value !== this.passPattern){
                return callback(new Error(`Pass phrase must be equal to ${this.passPattern} in uppercase.`));
            }
            callback();
        },
        reconfigure(action){
            let item = {
                reconfiguration_type: action,
                status: 'PENDING',
                redundancy_type: this.redundancyType,
                reconfiguration_module: this.moduleType,
                flow_arn: this.flowArn,
                flow_uid: this.flowUid,
                node_name: this.resourceName,
                configuration_uid: this.confUid,
            };
            if(this.resourceIsFeed){
                item['feed_uid'] = this.resource.uid;

            }else{
                item['channel_uid'] = this.resource.uid;
            }
            this.$store.dispatch('createItem',{
                item: item,
                scopes: {'X-Entity-Uid': this.resource.scopes.entity_uid},
                model: 'reconfiguration',
                url: this.$store.state.api.meta.listModels.reconfiguration.url
            }).then((res)=>{
                this.$emit('watchModelStatus', res.url);
                this.close();
            }).catch((e)=>{
                console.error(e);
            });
        },
        restart(){
            this.reconfigure('RESTART');
        },
        recreate(){
            this.$refs.form.validate(async (valid) => {
                if(!valid) return;
                this.reconfigure('RECREATE');
            });
        },
        reconfigureTaker(){
            this.$refs.form.validate(async (valid) => {
                if(!valid) return;
                this.reconfigure('RECONFIGURE');
            });
        }
    }
};
</script>

<style lang="css" scoped>
    .modal-wrapper{
        position: fixed;
        top: 0;
        left: 0;
        width:  100%;
        height:  100% !important;
        z-index: 2001 !important;
        overflow: hidden;
        background-color: rgba(0, 0, 0, 0.6);
    }
    .modal-container{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 150%;

        background-color: #121212;
        padding: 4rem;
        max-width: 575px;
        z-index: 9999;
        position: relative;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
    .modal-title{
        font-family: 'Montserrat' !important;
        text-transform: none !important;
        font-weight: 700;
        font-size: 18px;
        color:  white;
        margin-bottom: 4rem;
        display: flex;
        align-items: center;
    }
    .title{
        margin-left: 1rem;
    }
    .close-icon{
        color: white;
        margin-left: auto;
    }
    .resource-name{
        font-weight: 500;
        color:  white;
        margin-bottom: 1rem;
    }
    .modal-text{
        color : #BBBBBB;
        margin-bottom: 1rem;
    }
    .button-container{
        margin-top: 3rem;
        display: flex;
        justify-content: flex-end;
    }
    .cancel-button{
        background-color: #121212;
        border: solid 1px white;
    }
    .important-text{
        color: #a94442;
        font-weight: 700;
    }

</style>


// WEBPACK FOOTER //
// src/components/page/Monitoring/ResourceActionBtn/action-confirm-modal.vue